import { Media } from '@/payload-types'
import FlowbiteIconComponent from '../flowbite-icon/flowbiteIcon'
import PopoverComponent from '../popover/popover'
import { useState } from 'react'
import { MediaCarousel } from '../galleries/media-carousel/mediaCarousel'
interface IProps {
  filteredMedia: (string | Media)[]
}

const MediaPopover = ({ filteredMedia }: IProps) => {
  const [isMediaPopoverOpen, setIsMediaPopoverOpen] = useState(false)
  return (
    <PopoverComponent
      open={isMediaPopoverOpen}
      setOpen={setIsMediaPopoverOpen}
      buttonClassName={`flex-1 h-[30px] bg-gray-600 rounded-lg border border-white ${
        isMediaPopoverOpen ? 'bg-transparent !border-gray-600 border-2' : ''
      }`}
      buttonChildren={
        <div
          className={`lg:text-sm text-xs ${
            isMediaPopoverOpen ? 'text-gray-600' : 'text-white'
          } flex items-center justify-center`}
        >
          View Media
          <FlowbiteIconComponent
            iconType="AngleDown"
            className={`transition-transform duration-500 ${
              isMediaPopoverOpen ? 'rotate-180' : ''
            }`}
          />
        </div>
      }
    >
      <div className="p-2 relative bg-white rounded-lg border border-gray-600 w-[250px] sm:w-[290px] h-[250px]">
        <MediaCarousel media={filteredMedia} />
      </div>
    </PopoverComponent>
  )
}

export default MediaPopover
